import React, { useState, useEffect } from 'react';
import './AgeVerification.css';

const AgeVerification = ({ onVerified }) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        // 檢查 localStorage 是否已經驗證過
        const isVerified = localStorage.getItem('ageVerified');
        if (!isVerified) {
            setShowModal(true);
        } else {
            onVerified();
        }
    }, [onVerified]);

    const handleConfirm = () => {
        // 儲存驗證狀態到 localStorage
        localStorage.setItem('ageVerified', 'true');
        setShowModal(false);
        onVerified();
    };

    const handleDecline = () => {
        // 如果用戶選擇「否」，重定向到其他網站或顯示提示
        window.location.href = 'https://www.google.com';
    };

    if (!showModal) {
        return null;
    }

    return (
        <div className="age-verification-overlay">
            <div className="age-verification-modal">
                <div className="age-verification-content">
                    <h2 className="age-verification-title">年齡確認</h2>
                    <p className="age-verification-text">
                        此論壇可能包含成人內容。
                    </p>
                    <p className="age-verification-question">
                        您是否已年滿18歲？
                    </p>
                    <div className="age-verification-buttons">
                        <button
                            className="age-verification-btn confirm-btn"
                            onClick={handleConfirm}
                        >
                            是，我已年滿18歲
                        </button>
                        <button
                            className="age-verification-btn decline-btn"
                            onClick={handleDecline}
                        >
                            否
                        </button>
                    </div>
                    <p className="age-verification-disclaimer">
                        點擊「是」即表示您確認已年滿18歲，並同意瀏覽本網站內容。
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AgeVerification;
